import { useTheme } from "@emotion/react";
import React from "react";
import { MdWarningAmber } from "react-icons/md";

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  title?: React.ReactNode;
  className?: string;
};

export const AlertCard: React.FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  const icon = props.icon ?? <MdWarningAmber size={18} />;

  return (
    <div
      className={props.className}
      css={{
        display: "flex",
        flexDirection: "column",
        gap: "0.675rem",
        padding: "1rem",
        borderRadius: theme.smallBorderRadius,
        background: theme.colors.dangerBackground,
        border: `1px solid rgba(0,0,0,0.1)`,
        width: "100%",
        fontSize: "0.875rem",
        ":hover": {
          textDecoration: "none",
        },
      }}
    >
      <div
        css={{
          display: "flex",
          gap: "0.5rem",
          color: theme.colors.danger,
          fontSize: "1rem",
          alignItems: "center",
          fontWeight: 700,
        }}
      >
        {icon}
        {props.title}
      </div>
      {props.children}
    </div>
  );
};
